// TODO: remove this lint
// SFC has specified a displayName, but not worked.
/* eslint-disable react/display-name */
import * as React from 'react';
import { FormProvider as RcFormProvider } from 'rc-field-form';
import { RenderEmptyHandler } from './renderEmpty';
import LocaleProvider, { ANT_MARK } from '../locale-provider';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { ConfigConsumer, ConfigContext, CSPConfig, ConfigConsumerProps } from './context';
import { SizeContextProvider } from './SizeContext';
export { RenderEmptyHandler, ConfigContext, ConfigConsumer, CSPConfig, ConfigConsumerProps };
export const configConsumerProps = [
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale',
    'pageHeader',
];
class ConfigProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.getPrefixClsWrapper = (context) => {
            return (suffixCls, customizePrefixCls) => {
                const { prefixCls } = this.props;
                if (customizePrefixCls)
                    return customizePrefixCls;
                const mergedPrefixCls = prefixCls || context.getPrefixCls('');
                return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
            };
        };
        this.renderProvider = (context, legacyLocale) => {
            const { children, getPopupContainer, renderEmpty, csp, autoInsertSpaceInButton, form, locale, pageHeader, componentSize, direction, space, } = this.props;
            const config = Object.assign(Object.assign({}, context), { getPrefixCls: this.getPrefixClsWrapper(context), csp,
                autoInsertSpaceInButton, locale: locale || legacyLocale, direction,
                space });
            if (getPopupContainer) {
                config.getPopupContainer = getPopupContainer;
            }
            if (renderEmpty) {
                config.renderEmpty = renderEmpty;
            }
            if (pageHeader) {
                config.pageHeader = pageHeader;
            }
            let childNode = children;
            // Additional Form provider
            let validateMessages = {};
            if (locale && locale.Form && locale.Form.defaultValidateMessages) {
                validateMessages = locale.Form.defaultValidateMessages;
            }
            if (form && form.validateMessages) {
                validateMessages = Object.assign(Object.assign({}, validateMessages), form.validateMessages);
            }
            if (Object.keys(validateMessages).length > 0) {
                childNode = <RcFormProvider validateMessages={validateMessages}>{children}</RcFormProvider>;
            }
            return (<SizeContextProvider size={componentSize}>
        <ConfigContext.Provider value={config}>
          <LocaleProvider locale={locale || legacyLocale} _ANT_MARK__={ANT_MARK}>
            {childNode}
          </LocaleProvider>
        </ConfigContext.Provider>
      </SizeContextProvider>);
        };
    }
    render() {
        return (<LocaleReceiver>
        {(_, __, legacyLocale) => (<ConfigConsumer>
            {context => this.renderProvider(context, legacyLocale)}
          </ConfigConsumer>)}
      </LocaleReceiver>);
    }
}
export default ConfigProvider;
